import { SERVICE_TECH_ROLES } from "@/lib/roles/turboServiceRoles";

export function passesServiceTechAppRoleGate(hasRole: (...roles: string[]) => boolean): boolean {
  return SERVICE_TECH_ROLES.some((r) => hasRole(r));
}
